import { useState, useEffect } from "react";
import { Analytics } from "@vercel/analytics/react";
import { calculateVerdict, DEFAULT_CONSUMPTION, DISTANCES, FUEL_PRICES } from "./crossBorderMath.js";

const Icons = {
  search: (c="currentColor") => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>,
  scan: (c="currentColor") => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7V5a2 2 0 0 1 2-2h2"/><path d="M17 3h2a2 2 0 0 1 2 2v2"/><path d="M21 17v2a2 2 0 0 1-2 2h-2"/><path d="M7 21H5a2 2 0 0 1-2-2v-2"/><line x1="3" y1="12" x2="21" y2="12"/></svg>,
  settings: (c="currentColor") => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>,
  home: (c="currentColor") => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  moon: (c="currentColor") => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>,
  sun: (c="currentColor") => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>,
  fuel: (c="currentColor") => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="22" x2="15" y2="22"/><line x1="4" y1="9" x2="14" y2="9"/><path d="M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18"/><path d="M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5"/></svg>,
  zap: (c="currentColor") => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
  check: (c="currentColor") => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  arrow: (c="currentColor") => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>,
  back: (c="currentColor") => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>,
  info: (c="currentColor") => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  close: (c="currentColor") => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
};

const T = {
  en: { appName:"Cheaperside", tagline:"Buy smarter across borders", searchPlaceholder:"Search product...", scan:"Scan barcode", settings:"Settings", home:"Home", chooseLanguage:"Choose your language", languageSubtitle:"You can change this in settings", darkMode:"Dark mode", lightMode:"Light mode", vehicle:"Vehicle", vehicleSubtitle:"For accurate fuel cost calculations", petrol:"Petrol", diesel:"Diesel", electric:"Electric", consumption:"Fuel consumption (L/100km)", saveSettings:"Save settings", searching:"Finding products...", noResults:"No results found", priceIn:"Price in", afterFuel:"after fuel", bestDeal:"Best deal", worthTheTrip:"Worth the trip!", stayLocal:"Stay local", saving:"You save", fuelCost:"Fuel cost", customsLimit:"Customs limit: CHF 150/person (since Jan 2026)", ch:"Switzerland", fr:"France", de:"Germany", recommendation:"Our recommendation", buyIn:"Buy in", back:"Back", selectProduct:"Select a product to compare", vatNote:"Prices before VAT refund · Fuel estimate based on 60-80km round trip", affiliateNotice:"Affiliate disclosure", affiliateText:"Cheaperside earns a commission on purchases via affiliate links at no extra cost to you. This helps us keep the app running. Information about customs limits and VAT is for guidance only — always check official rules.", priceDisclaimer:"Prices and availability are indicative and updated regularly. Always verify on the retailer site before purchasing.", checkRetailers:"Compare across borders", checkRetailersText:"Live prices from retailers in Switzerland, France, and Germany. Tap to buy at the best deal.", retailer:"retailer", retailers:"retailers", viewProduct:"View product", openSite:"Open →", crossBorderTips:"Cross-border tips", crossBorderTipsText:"Swiss customs limit is CHF 150/person. Add fuel costs (60-80km round trip) when buying in FR or DE. Foreign VAT can sometimes be refunded at the border.", tryDifferentTerm:"Try a more specific product name", verdictSetupTitle:"Travel basics", verdictSetupSub:"To tell you if crossing the border is worth it, we need a few details.", verdictSetupCity:"Closest city", verdictSetupVehicle:"Your vehicle", verdictSetupConsumption:"Fuel consumption (L/100km)", verdictSetupSave:"Save & continue", verdictSetupSkip:"Skip for now", verdictWorthIt:"Worth crossing to", verdictBorderline:"Borderline", verdictNotWorth:"Stay in Switzerland", verdictYouSave:"You save", verdictAfterCosts:"after fuel & VAT", verdictRoundTrip:"Round trip", verdictFuel:"Fuel", verdictSwissVat:"Swiss VAT (8.1%)", verdictTotalForeign:"Total in foreign country", verdictAboveAllowance:"Above CHF 150 allowance — declare at customs (Swiss VAT included above)", verdictTaxFreeNudge:"Tip: You can reclaim foreign VAT at the border with a tax-free form.", verdictLearnMore:"Learn how →", verdictNoSwissPrice:"No Swiss price available — add a Galaxus or Digitec result to enable comparison.", verdictDisclaimer:"Estimates only. Actual costs vary. Always verify customs rules at bazg.admin.ch.", verdictBorderlineMsg:"Tight margins. Worth it if you're already going for other reasons." },
  fr: { appName:"Cheaperside", tagline:"Achetez moins cher de l'autre côté", searchPlaceholder:"Rechercher un produit...", scan:"Scanner le code-barres", settings:"Paramètres", home:"Accueil", chooseLanguage:"Choisissez votre langue", languageSubtitle:"Modifiable dans les paramètres", darkMode:"Mode sombre", lightMode:"Mode clair", vehicle:"Véhicule", vehicleSubtitle:"Pour des calculs de carburant précis", petrol:"Essence", diesel:"Diesel", electric:"Électrique", consumption:"Consommation (L/100km)", saveSettings:"Enregistrer", searching:"Recherche des produits...", noResults:"Aucun résultat", priceIn:"Prix en", afterFuel:"après carburant", bestDeal:"Meilleure offre", worthTheTrip:"Ça vaut le déplacement!", stayLocal:"Restez local", saving:"Vous économisez", fuelCost:"Carburant", customsLimit:"Limite douanière: CHF 150/personne (depuis jan 2026)", ch:"Suisse", fr:"France", de:"Allemagne", recommendation:"Notre recommandation", buyIn:"Achetez en", back:"Retour", selectProduct:"Sélectionnez un produit", vatNote:"Prix avant TVA · Carburant estimé 60-80km aller-retour", affiliateNotice:"Divulgation d'affiliation", affiliateText:"Cheaperside perçoit une commission sur les achats via les liens d'affiliation, sans coût supplémentaire pour vous. Cela nous aide à maintenir l'app. Les informations sur les douanes et la TVA sont à titre indicatif — vérifiez toujours les règles officielles.", priceDisclaimer:"Les prix et la disponibilité sont indicatifs et mis à jour régulièrement. Vérifiez toujours sur le site du commerçant avant d'acheter.", checkRetailers:"Comparer entre pays", checkRetailersText:"Prix en direct des détaillants en Suisse, France et Allemagne. Touchez pour acheter au meilleur prix.", retailer:"détaillant", retailers:"détaillants", viewProduct:"Voir le produit", openSite:"Ouvrir →", crossBorderTips:"Conseils transfrontaliers", crossBorderTipsText:"La limite douanière suisse est de CHF 150/personne. Ajoutez le carburant (60-80km aller-retour) pour les achats en FR ou DE. La TVA étrangère peut parfois être remboursée à la frontière.", tryDifferentTerm:"Essayez un nom de produit plus spécifique", verdictSetupTitle:"Préparation voyage", verdictSetupSub:"Pour savoir si traverser la frontière vaut le coup, nous avons besoin de quelques détails.", verdictSetupCity:"Ville la plus proche", verdictSetupVehicle:"Votre véhicule", verdictSetupConsumption:"Consommation (L/100km)", verdictSetupSave:"Enregistrer et continuer", verdictSetupSkip:"Plus tard", verdictWorthIt:"Vaut la peine d'aller en", verdictBorderline:"Limite", verdictNotWorth:"Restez en Suisse", verdictYouSave:"Vous économisez", verdictAfterCosts:"après carburant et TVA", verdictRoundTrip:"Aller-retour", verdictFuel:"Carburant", verdictSwissVat:"TVA suisse (8.1%)", verdictTotalForeign:"Total dans le pays étranger", verdictAboveAllowance:"Au-dessus de la limite CHF 150 — déclarez à la douane (TVA suisse incluse ci-dessus)", verdictTaxFreeNudge:"Astuce: vous pouvez récupérer la TVA étrangère à la frontière avec un formulaire détaxe.", verdictLearnMore:"En savoir plus →", verdictNoSwissPrice:"Pas de prix suisse disponible — ajoutez un résultat Galaxus ou Digitec pour activer la comparaison.", verdictDisclaimer:"Estimations uniquement. Les coûts réels varient. Vérifiez toujours les règles douanières sur bazg.admin.ch.", verdictBorderlineMsg:"Marge serrée. Cela vaut le coup si vous y allez déjà pour d'autres raisons." },
  de: { appName:"Cheaperside", tagline:"Günstiger über die Grenze einkaufen", searchPlaceholder:"Produkt suchen...", scan:"Barcode scannen", settings:"Einstellungen", home:"Startseite", chooseLanguage:"Sprache wählen", languageSubtitle:"Später in Einstellungen änderbar", darkMode:"Dunkelmodus", lightMode:"Hellmodus", vehicle:"Fahrzeug", vehicleSubtitle:"Für genaue Kraftstoffberechnungen", petrol:"Benzin", diesel:"Diesel", electric:"Elektrisch", consumption:"Kraftstoffverbrauch (L/100km)", saveSettings:"Speichern", searching:"Produkte werden gesucht...", noResults:"Keine Ergebnisse", priceIn:"Preis in", afterFuel:"nach Kraftstoff", bestDeal:"Bestes Angebot", worthTheTrip:"Die Fahrt lohnt sich!", stayLocal:"Lokal kaufen", saving:"Sie sparen", fuelCost:"Kraftstoff", customsLimit:"Zollgrenze: CHF 150/Person (seit Jan 2026)", ch:"Schweiz", fr:"Frankreich", de:"Deutschland", recommendation:"Unsere Empfehlung", buyIn:"Kaufen in", back:"Zurück", selectProduct:"Produkt auswählen", vatNote:"Preise vor MwSt. · Kraftstoff geschätzt 60-80km Rundfahrt", affiliateNotice:"Affiliate-Hinweis", affiliateText:"Cheaperside erhält eine Provision bei Käufen über Affiliate-Links ohne Mehrkosten für Sie. Dies hilft uns, die App zu betreiben. Informationen zu Zoll und MwSt. dienen nur zur Orientierung — überprüfen Sie immer die offiziellen Regeln.", priceDisclaimer:"Preise und Verfügbarkeit sind unverbindlich und werden regelmäßig aktualisiert. Überprüfen Sie immer auf der Händler-Website vor dem Kauf.", checkRetailers:"Über Grenzen vergleichen", checkRetailersText:"Live-Preise von Händlern in der Schweiz, Frankreich und Deutschland. Tippen Sie zum Kauf zum besten Preis.", retailer:"Händler", retailers:"Händler", viewProduct:"Produkt ansehen", openSite:"Öffnen →", crossBorderTips:"Grenzüberschreitende Tipps", crossBorderTipsText:"Die Schweizer Zollgrenze beträgt CHF 150/Person. Berücksichtigen Sie Kraftstoffkosten (60-80km Rundfahrt) bei Käufen in FR oder DE. Ausländische MwSt. kann manchmal an der Grenze erstattet werden.", tryDifferentTerm:"Versuchen Sie einen spezifischeren Produktnamen", verdictSetupTitle:"Reisedetails", verdictSetupSub:"Um zu sagen, ob sich der Grenzübergang lohnt, brauchen wir ein paar Angaben.", verdictSetupCity:"Nächste Stadt", verdictSetupVehicle:"Ihr Fahrzeug", verdictSetupConsumption:"Verbrauch (L/100km)", verdictSetupSave:"Speichern und weiter", verdictSetupSkip:"Später", verdictWorthIt:"Lohnt sich nach", verdictBorderline:"Grenzwertig", verdictNotWorth:"In der Schweiz bleiben", verdictYouSave:"Sie sparen", verdictAfterCosts:"nach Kraftstoff und MwSt.", verdictRoundTrip:"Hin und zurück", verdictFuel:"Kraftstoff", verdictSwissVat:"Schweizer MwSt. (8.1%)", verdictTotalForeign:"Gesamt im Ausland", verdictAboveAllowance:"Über CHF 150 Freigrenze — am Zoll deklarieren (Schweizer MwSt. oben eingerechnet)", verdictTaxFreeNudge:"Tipp: Sie können die ausländische MwSt. mit einem Tax-Free-Formular an der Grenze zurückerhalten.", verdictLearnMore:"Mehr erfahren →", verdictNoSwissPrice:"Kein Schweizer Preis verfügbar — fügen Sie ein Galaxus- oder Digitec-Ergebnis hinzu.", verdictDisclaimer:"Nur Schätzungen. Tatsächliche Kosten variieren. Prüfen Sie Zollregeln auf bazg.admin.ch.", verdictBorderlineMsg:"Knappe Margen. Lohnt sich, wenn Sie ohnehin hinfahren." },
};

const th = (dark) => ({
  bg: dark ? "#080810" : "#f5f5f0",
  surface: dark ? "#13131f" : "#ffffff",
  surface2: dark ? "#1e1e2e" : "#ebebeb",
  border: dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)",
  text: dark ? "#f0f0ff" : "#0d0d1a",
  muted: dark ? "#6b6b80" : "#8888a0",
  accent: "#3dffa0",
  accent2: "#5b8fff",
  sep: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
});

function Toggle({ dark, onToggle }) {
  return (
    <div onClick={onToggle} style={{ width:50, height:28, borderRadius:14, background: dark?"#00e5a0":"#e5e5ea", position:"relative", cursor:"pointer", transition:"background 0.3s", flexShrink:0 }}>
      <div style={{ position:"absolute", top:3, left: dark?25:3, width:22, height:22, borderRadius:11, background:"#fff", transition:"left 0.25s", boxShadow:"0 2px 6px rgba(0,0,0,0.25)" }} />
    </div>
  );
}

function Spinner() {
  return <div style={{ width:28, height:28, border:"3px solid rgba(0,229,160,0.2)", borderTopColor:"#00e5a0", borderRadius:"50%", animation:"spin 0.8s linear infinite", margin:"0 auto" }} />;
}

// Sidebar nav for desktop
function SidebarNav({ tab, setTab, t, theme, dark, toggleDark }) {
  const navItems = [
    { id:"home", icon:Icons.home, label:t.home },
    { id:"settings", icon:Icons.settings, label:t.settings },
  ];
  return (
    <div style={{
      width: 200,
      flexShrink: 0,
      background: dark ? "#111115" : "#f7f7f9",
      borderRight: `1px solid ${theme.border}`,
      display: "flex",
      flexDirection: "column",
      padding: "24px 10px 20px",
      height: "100vh",
      overflowY: "auto",
    }}>
      {/* Logo */}
      <div style={{ marginBottom: 32, paddingLeft: 10, paddingBottom: 20, borderBottom: `1px solid ${theme.sep}` }}>
        <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:4 }}><div style={{ fontSize:20, fontWeight:800, background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", letterSpacing:-0.8 }}>Cheaperside</div><span style={{fontSize:13}}>🇨🇭🇫🇷🇩🇪</span></div>
        <div style={{ fontSize:11, color:theme.muted, fontWeight:500, letterSpacing:0.3 }}>CH · FR · DE price compare</div>
      </div>

      {/* Nav items */}
      <div style={{ display:"flex", flexDirection:"column", gap:4, flex:1 }}>
        {navItems.map(item => (
          <button key={item.id} onClick={() => setTab(item.id)} style={{
            display:"flex", alignItems:"center", gap:12,
            background: tab===item.id ? "rgba(0,229,160,0.1)" : "transparent",
            border: "none",
            borderRadius:10, padding:"10px 12px", color: tab===item.id ? "#00e5a0" : theme.muted,
            fontFamily:"'DM Sans', sans-serif", fontSize:14, fontWeight:600, cursor:"pointer", transition:"all 0.15s", textAlign:"left", width:"100%",
          }}
          onMouseEnter={e => { if (tab!==item.id) { e.currentTarget.style.background=dark?"rgba(255,255,255,0.06)":"rgba(0,0,0,0.05)"; e.currentTarget.style.color=dark?"#fff":"#111"; }}}
          onMouseLeave={e => { if (tab!==item.id) { e.currentTarget.style.background="transparent"; e.currentTarget.style.color=theme.muted; }}}>
            {item.icon(tab===item.id ? "#00e5a0" : theme.muted)}
            <span>{item.label}</span>
          </button>
        ))}
      </div>

      {/* Dark mode toggle at bottom */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", paddingLeft:8, paddingRight:4 }}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          {dark ? Icons.moon("#ffd60a") : Icons.sun("#8e8e93")}
          <span style={{ fontSize:12, color:theme.muted, fontWeight:600 }}>{dark ? "Dark" : "Light"}</span>
        </div>
        <Toggle dark={dark} onToggle={toggleDark} />
      </div>
    </div>
  );
}

// Bottom nav for mobile (unchanged)
function BottomNav({ tab, setTab, t, theme, dark }) {
  return (
    <div style={{
      position:"fixed", bottom:0, left:0, right:0,
      background: dark?"#080810":"#f5f5f0",
      borderTop:`1px solid ${theme.sep}`,
      display:"flex", justifyContent:"space-around",
      paddingBottom:"env(safe-area-inset-bottom, 20px)", paddingTop:10, zIndex:100,
      boxShadow:"0 -1px 0px rgba(0,0,0,0.1)"
    }}>
      {[{id:"home"},{id:"settings"}].map(item => (
        <button key={item.id} onClick={()=>setTab(item.id)} style={{
          flex:1, display:"flex", alignItems:"center", justifyContent:"center",
          background:"transparent", border:"none",
          color: tab===item.id?theme.accent:theme.muted,
          padding:"10px 0", transition:"color 0.2s"
        }}>
          {item.id==="home"
            ? <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9.5z"/><path d="M9 21v-8h6v8"/></svg>
            : <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
          }
        </button>
      ))}
    </div>
  );
}

export default function App() {
  const [dark, setDark] = useState(true);
  const [lang, setLang] = useState(null);
  const [tab, setTab] = useState("home");
  const [toast, setToast] = useState(null);
  const [vehicle, setVehicle] = useState({ type:"petrol", consumption:7 });
  const [userLocation] = useState(null);
  const [query, setQuery] = useState("");
  const [searching, setSearching] = useState(false);
  const [results, setResults] = useState(null);
  const [selected, setSelected] = useState(null);
  const [comparing, setComparing] = useState(false);
  const [comparison, setComparison] = useState(null);
  const [rate, setRate] = useState(0.985);
  const [isDesktop, setIsDesktop] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [travelProfile, setTravelProfile] = useState(null);
  const [showTravelSetup, setShowTravelSetup] = useState(false);
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [proEmail, setProEmail] = useState("");
  const [checkingPro, setCheckingPro] = useState(false);
  const [searchHistory, setSearchHistory] = useState([]);
  const [searchCount, setSearchCount] = useState(0);
  const [isPro, setIsPro] = useState(false);
  const [countryFilter, setCountryFilter] = useState('all');

  const theme = th(dark);
  const t = lang ? T[lang] : T.en;

  useEffect(() => {
    const l = localStorage.getItem("cs_lang");
    const d = localStorage.getItem("cs_dark");
    const v = localStorage.getItem("cs_vehicle");
    if (l) setLang(l);
    if (d !== null) setDark(d === "true");
    if (v) setVehicle(JSON.parse(v));
    const tp = localStorage.getItem("cs_travel_profile");
    if (tp) {
      try { setTravelProfile(JSON.parse(tp)); } catch(e) {}
    }
    if (!localStorage.getItem("cs_welcomed")) setShowWelcome(true);
    const h = localStorage.getItem("cs_history");
    if (h) setSearchHistory(JSON.parse(h));
    const pro = localStorage.getItem("cs_pro");
    if (pro === "true") setIsPro(true);
    const savedEmail = localStorage.getItem("cs_pro_email");
    if (savedEmail) setProEmail(savedEmail);
    // Reset count if last search was a different day
    const lastDate = localStorage.getItem("cs_search_date");
    const today = new Date().toDateString();
    if (lastDate !== today) {
      localStorage.setItem("cs_search_date", today);
      localStorage.setItem("cs_search_count", "0");
      setSearchCount(0);
    } else {
      const cnt = parseInt(localStorage.getItem("cs_search_count") || "0");
      setSearchCount(cnt);
    }
    fetch("https://api.exchangerate-api.com/v4/latest/CHF")
      .then(r => r.json()).then(d => setRate(d.rates.EUR)).catch(() => {});
  }, []);

  useEffect(() => {
    const checkDesktop = () => setIsDesktop(window.innerWidth >= 768);
    checkDesktop();
    window.addEventListener("resize", checkDesktop);
    return () => window.removeEventListener("resize", checkDesktop);
  }, []);

  function toast_(msg, type="success") { setToast({ msg, type }); setTimeout(() => setToast(null), 3000); }
  function selectLang(l) { setLang(l); localStorage.setItem("cs_lang", l); }
  function toggleDark() { const n = !dark; setDark(n); localStorage.setItem("cs_dark", String(n)); }
  function saveVehicle(v) { setVehicle(v); localStorage.setItem("cs_vehicle", JSON.stringify(v)); toast_("Saved!"); }
  function clearAll() { setQuery(""); setResults(null); setSelected(null); setComparison(null); }

  async function checkProStatus(email) {
    if (!email || !email.includes("@")) return;
    setCheckingPro(true);
    try {
      const r = await fetch("/api/check-pro", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await r.json();
      if (data.pro) {
        setIsPro(true);
        localStorage.setItem("cs_pro", "true");
        localStorage.setItem("cs_pro_email", email);
        toast_("Pro access unlocked!");
        setShowUpgrade(false);
      } else {
        toast_("Email not found. Please purchase first.", "error");
      }
    } catch(e) {
      console.error(e);
    }
    setCheckingPro(false);
  }

  async function doSearch() {
    if (!query.trim()) return;
    if (!isPro && searchCount >= 3) {
      setShowUpgrade(true);
      return;
    }
    setSearching(true); setResults(null); setSelected(null); setComparison(null); setCountryFilter('all');
    try {
      const r = await fetch(`/api/search-v2?q=${encodeURIComponent(query.trim())}&limit=30`);
      const data = await r.json();
      const items = Array.isArray(data.results) ? data.results : [];

      // Map V2 results to UI shape
      const results = items.map(p => ({
        title: p.title,
        thumbnail: p.image_url || null,
        price: p.price ? `${p.currency === 'CHF' ? 'CHF ' : ''}${p.price}${p.currency === 'EUR' ? ' €' : p.currency === 'GBP' ? ' £' : ''}` : null,
        priceNum: p.price,
        priceOld: p.price_old,
        currency: p.currency,
        discount: p.discount_percentage,
        source: p.retailer || p.brand || '',
        country: p.country,
        clickUrl: p.click_url,
        ean: p.ean,
        brand: p.brand,
      }));

      if (results.length > 0) {
        const newCount = searchCount + 1;
        setSearchCount(newCount);
        localStorage.setItem("cs_search_count", String(newCount));
        localStorage.setItem("cs_search_date", new Date().toDateString());
        setSearchHistory(prev => {
          const updated = [query.trim(), ...prev.filter(h => h.toLowerCase() !== query.trim().toLowerCase())].slice(0, 10);
          localStorage.setItem("cs_history", JSON.stringify(updated));
          return updated;
        });
        setResults(results);
      } else {
        setResults([]);
      }
    } catch(e) {
      console.error(e);
      setResults([]);
    }
    setSearching(false);
  }

  // Fans out 6 parallel API calls (one per retailer) and updates UI as results arrive.
  // Each call has its own timeout, so a slow/failing retailer doesn't block the others.
  async function fetchAllRetailers(productTitle) {
    // Only active scrapers — disabled ones (galaxus/digitec/rakuten) return null and waste a slot.
    // ScraperAPI free tier has concurrency 5; with 3 retailers we never queue.
    const RETAILERS = [
      { id: 'fnac',       country: 'fr' },
      { id: 'mediamarkt', country: 'de' },
      { id: 'saturn',     country: 'de' },
    ];

    // Initialize empty state — UI will populate as results stream in
    setComparison({ ch: [], fr: [], de: [], loc: userLocation });

    // Track results in a local accumulator so updates compose correctly
    const acc = { ch: [], fr: [], de: [] };

    await Promise.all(RETAILERS.map(async ({ id, country }) => {
      try {
        const ctrl = new AbortController();
        const timeout = setTimeout(() => ctrl.abort(), 35000);
        const r = await fetch("/api/search", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mode: "compare-one", retailer: id, product: productTitle }),
          signal: ctrl.signal,
        });
        clearTimeout(timeout);
        if (!r.ok) return;
        const result = await r.json();
        if (result && result.price > 0) {
          acc[country] = [...acc[country], result];
          // Update the UI with whatever we have so far
          setComparison({ ch: [...acc.ch], fr: [...acc.fr], de: [...acc.de], loc: userLocation });
        }
      } catch (e) {
        // Per-retailer failure is non-fatal — just skip it
        console.warn(`${id} failed:`, e.message);
      }
    }));
  }

  async function doCompare(product) {
    if (!travelProfile) setShowTravelSetup(true);
    setSelected(product); setComparing(true); setComparison(null);
    try {
      await fetchAllRetailers(product.title);
    } catch(e) {
      console.error(e);
      toast_("Comparison failed.", "error");
    }
    setComparing(false);
  }

  // eslint-disable-next-line no-unused-vars
  async function doCompareByQuery(q) {
    if (!travelProfile) setShowTravelSetup(true);
    // Go straight to compare using raw search query — skips CH product list
    setSelected({ title: q }); setComparing(true); setComparison(null);
    try {
      await fetchAllRetailers(q);
      const newCount = searchCount + 1;
      setSearchCount(newCount);
      localStorage.setItem("cs_search_count", String(newCount));
      localStorage.setItem("cs_search_date", new Date().toDateString());
      setSearchHistory(prev => {
        const updated = [q, ...prev.filter(h => h.toLowerCase() !== q.toLowerCase())].slice(0, 10);
        localStorage.setItem("cs_history", JSON.stringify(updated));
        return updated;
      });
    } catch(e) {
      console.error(e);
      toast_("Search failed. Try again.", "error");
    }
    setComparing(false);
  }

  const globalStyles = `
    *{box-sizing:border-box;margin:0;padding:0}
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;1,9..40,400&family=DM+Mono:wght@400;500&display=swap');
    html,body{background:${dark?"#080810":"#f5f5f0"};overflow-x:hidden;height:100%;overscroll-behavior-y:none;font-family:'DM Sans',sans-serif}#root{height:100%}
    body{background-color:${dark?"#080810":"#f5f5f0"} !important}
    :root{color-scheme:${dark?"dark":"light"}}
    *{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}
    input,button{font-family:'DM Sans',sans-serif}
    @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
    @keyframes fadeIn{from{opacity:0}to{opacity:1}}
    @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
    input:focus,button:focus{outline:none}
    ::-webkit-scrollbar{display:none}
    button{cursor:pointer;font-family:inherit}
  `;

  // Upgrade modal
  if (showUpgrade) return (
    <div style={{ minHeight:"100vh", background:theme.bg, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24, fontFamily:"'DM Sans', sans-serif" }}>
      <style>{`*{box-sizing:border-box;margin:0;padding:0}@keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div style={{ animation:"fadeUp 0.4s ease", textAlign:"center", maxWidth:400, width:"100%" }}>
        <div style={{ fontSize:48, marginBottom:16 }}>🔒</div>
        <h2 style={{ fontSize:26, fontWeight:800, color:theme.text, marginBottom:8, letterSpacing:-0.5 }}>Go unlimited</h2>
        <p style={{ color:theme.muted, fontSize:14, marginBottom:24, lineHeight:1.6 }}>You have used your 3 free searches for today. Upgrade to keep searching.</p>

        {/* Yearly plan — recommended */}
        <div style={{ background:theme.surface, border:"2px solid #00e5a0", borderRadius:20, padding:20, marginBottom:12, position:"relative" }}>
          <div style={{ position:"absolute", top:-10, right:16, background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 100%)", color:"#000", fontSize:10, fontWeight:800, padding:"4px 10px", borderRadius:8, letterSpacing:0.5, textTransform:"uppercase" }}>Save 35%</div>
          <p style={{ fontSize:13, color:"#00e5a0", fontWeight:700, letterSpacing:0.8, textTransform:"uppercase", marginBottom:6 }}>Yearly</p>
          <p style={{ fontSize:36, fontWeight:800, color:theme.text, marginBottom:2 }}>CHF 39<span style={{fontSize:14,color:theme.muted,fontWeight:500}}>/year</span></p>
          <p style={{ fontSize:12, color:theme.muted, marginBottom:14 }}>That's just CHF 3.25/month · Unlimited searches</p>
          <button onClick={() => {
              const email = proEmail.trim();
              const base = "https://buy.stripe.com/bJe5kC59Q9ax9JLc1Mffy00"; // TODO: replace with yearly Stripe link
              const url = email.includes("@") ? `${base}?prefilled_email=${encodeURIComponent(email)}` : base;
              window.open(url, "_blank");
              if (email.includes("@")) {
                let attempts = 0;
                const poll = setInterval(async () => {
                  attempts++;
                  try {
                    const r = await fetch("/api/check-pro", { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({email}) });
                    const data = await r.json();
                    if (data.pro) {
                      setIsPro(true);
                      localStorage.setItem("cs_pro","true");
                      localStorage.setItem("cs_pro_email",email);
                      toast_("Pro access unlocked!");
                      setShowUpgrade(false);
                      clearInterval(poll);
                    }
                  } catch(e) {}
                  if (attempts >= 20) clearInterval(poll);
                }, 10000);
              }
            }}
            style={{ width:"100%", background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)", border:"none", borderRadius:14, padding:"14px", color:"#000", fontSize:15, fontWeight:800, cursor:"pointer" }}>
            Get Yearly →
          </button>
        </div>

        {/* Monthly plan */}
        <div style={{ background:theme.surface, border:`1.5px solid ${theme.border}`, borderRadius:20, padding:18, marginBottom:16 }}>
          <p style={{ fontSize:13, color:theme.muted, fontWeight:700, letterSpacing:0.8, textTransform:"uppercase", marginBottom:6 }}>Monthly</p>
          <p style={{ fontSize:30, fontWeight:800, color:theme.text, marginBottom:2 }}>CHF 4.99<span style={{fontSize:14,color:theme.muted,fontWeight:500}}>/month</span></p>
          <p style={{ fontSize:12, color:theme.muted, marginBottom:12 }}>Cancel anytime · Unlimited searches</p>
          <button onClick={() => {
              const email = proEmail.trim();
              const base = "https://buy.stripe.com/bJe5kC59Q9ax9JLc1Mffy00"; // TODO: replace with monthly Stripe link
              const url = email.includes("@") ? `${base}?prefilled_email=${encodeURIComponent(email)}` : base;
              window.open(url, "_blank");
              if (email.includes("@")) {
                let attempts = 0;
                const poll = setInterval(async () => {
                  attempts++;
                  try {
                    const r = await fetch("/api/check-pro", { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({email}) });
                    const data = await r.json();
                    if (data.pro) {
                      setIsPro(true);
                      localStorage.setItem("cs_pro","true");
                      localStorage.setItem("cs_pro_email",email);
                      toast_("Pro access unlocked!");
                      setShowUpgrade(false);
                      clearInterval(poll);
                    }
                  } catch(e) {}
                  if (attempts >= 20) clearInterval(poll);
                }, 10000);
              }
            }}
            style={{ width:"100%", background:theme.surface2, border:`1px solid ${theme.border}`, borderRadius:14, padding:"12px", color:theme.text, fontSize:14, fontWeight:700, cursor:"pointer" }}>
            Get Monthly →
          </button>
        </div>

        {/* Email + restore */}
        <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:14, padding:14, marginBottom:16 }}>
          <input type="email" placeholder="your@email.com (required for purchase)" value={proEmail} onChange={e => setProEmail(e.target.value)} style={{ width:"100%", background:theme.surface2, border:`1px solid ${theme.border}`, borderRadius:10, padding:"10px 12px", color:theme.text, fontSize:14, fontFamily:"'DM Sans', sans-serif", marginBottom:10 }} />
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <p style={{ fontSize:11, color:theme.muted, flex:1, textAlign:"left" }}>Already subscribed?</p>
            <button onClick={() => checkProStatus(proEmail)} disabled={checkingPro}
              style={{ background:"transparent", border:`1px solid ${theme.border}`, borderRadius:10, padding:"6px 12px", color:"#00e5a0", fontWeight:700, fontSize:12, cursor:"pointer", whiteSpace:"nowrap" }}>
              {checkingPro ? "..." : "Restore"}
            </button>
          </div>
        </div>

        <button onClick={() => setShowUpgrade(false)}
          style={{ background:"transparent", border:"none", color:theme.muted, fontSize:13, cursor:"pointer" }}>
          Come back tomorrow for 3 more free searches
        </button>
      </div>
    </div>
  );

  // Welcome screen — first visit only
  if (showWelcome) return (
    <div style={{ minHeight:"100vh", background:theme.bg, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"24px 24px", fontFamily:"'DM Sans', sans-serif" }}>
      <style>{`*{box-sizing:border-box;margin:0;padding:0}@keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}`}</style>
      <div style={{ animation:"fadeUp 0.5s ease", textAlign:"center", maxWidth:440, width:"100%" }}>
        <div style={{ marginBottom:32 }}>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:10, marginBottom:8 }}><div style={{ fontSize:42, fontWeight:800, background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", letterSpacing:-1.5 }}>Cheaperside</div><span style={{fontSize:22}}>🇨🇭🇫🇷🇩🇪</span></div>
          <div style={{ fontSize:16, color:theme.muted, fontWeight:500 }}>Buy smarter across borders</div>
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:36 }}>
          {[
            { icon: Icons.search("#00e5a0"), title:"Search any product", desc:"Electronics, appliances, DIY, sports — anything you want to buy." },
            { icon: Icons.zap("#00b8ff"), title:"Compare CH · FR · DE prices", desc:"We factor in fuel cost and the CHF 150 customs limit automatically." },
            { icon: Icons.arrow("#00e5a0"), title:"Buy at the best price", desc:"Go directly to the cheapest store with one tap." },
          ].map((item, i) => (
            <div key={i} style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:18, padding:"16px 20px", display:"flex", gap:16, alignItems:"center", textAlign:"left", animation:`fadeUp 0.5s ${0.1+i*0.1}s ease both` }}>
              <div style={{ width:40, height:40, borderRadius:12, background:"rgba(0,229,160,0.08)", border:`1px solid rgba(0,229,160,0.15)`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>{item.icon}</div>
              <div>
                <p style={{ fontWeight:700, fontSize:15, color:theme.text, marginBottom:3 }}>{item.title}</p>
                <p style={{ fontSize:13, color:theme.muted, lineHeight:1.5 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <button onClick={() => { localStorage.setItem("cs_welcomed", "true"); setShowWelcome(false); }}
          style={{ width:"100%", background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)", border:"none", borderRadius:18, padding:"16px", color:"#000", fontSize:16, fontWeight:800, cursor:"pointer", animation:"fadeUp 0.5s 0.4s ease both", letterSpacing:-0.3 }}>
          Get started →
        </button>
        <p style={{ color:theme.muted, fontSize:11, marginTop:16 }}>Free · No account needed · CH 🇨🇭 FR 🇫🇷 DE 🇩🇪</p>
      </div>
    </div>
  );

  // Language selection screen
  if (!lang) return (
    <div style={{ minHeight:"100vh", background:theme.bg, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24, fontFamily:"'DM Sans', sans-serif" }}>
      <style>{`*{box-sizing:border-box;margin:0;padding:0}@keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
      <div style={{ position:"absolute", top:20, right:20 }}><Toggle dark={dark} onToggle={toggleDark}/></div>
      <div style={{ animation:"fadeUp 0.5s ease", textAlign:"center", maxWidth:360, width:"100%" }}>
        <div style={{ marginBottom:48 }}>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:10, marginBottom:8 }}><div style={{ fontSize:40, fontWeight:800, background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", letterSpacing:-1.5 }}>Cheaperside</div><span style={{fontSize:20}}>🇨🇭🇫🇷🇩🇪</span></div>
          <div style={{ fontSize:24 }}>🇨🇭 🇫🇷 🇩🇪</div>
        </div>
        <h2 style={{ color:theme.text, fontSize:24, fontWeight:700, marginBottom:8 }}>{T.en.chooseLanguage}</h2>
        <p style={{ color:theme.muted, fontSize:14, marginBottom:32 }}>{T.en.languageSubtitle}</p>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          {[{code:"en",label:"English",flag:"🇬🇧"},{code:"fr",label:"Français",flag:"🇫🇷"},{code:"de",label:"Deutsch",flag:"🇩🇪"}].map((l,i) => (
            <button key={l.code} onClick={()=>selectLang(l.code)}
              style={{ display:"flex", alignItems:"center", gap:16, background:theme.surface, border:`1.5px solid ${theme.border}`, borderRadius:18, padding:"18px 20px", cursor:"pointer", fontFamily:"'DM Sans', sans-serif", color:theme.text, animation:`fadeUp 0.5s ${0.1+i*0.08}s ease both`, transition:"all 0.2s" }}
              onMouseEnter={e=>{e.currentTarget.style.borderColor="#00e5a0";e.currentTarget.style.transform="translateY(-1px)"}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor=theme.border;e.currentTarget.style.transform="translateY(0)"}}>
              <span style={{fontSize:28}}>{l.flag}</span>
              <span style={{fontSize:17,fontWeight:600}}>{l.label}</span>
              <span style={{marginLeft:"auto"}}>{Icons.arrow(theme.muted)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  // Desktop layout
  if (isDesktop) {
    return (
      <div style={{
        height:"100vh",
        background: dark ? "#050508" : "#e8e8ed",
        fontFamily:"'DM Sans', sans-serif",
        color:theme.text,
        display:"flex",
        overflow:"hidden",
      }}>
        <style>{globalStyles}</style>

        {toast && <div style={{ position:"fixed", top:24, left:"50%", transform:"translateX(-50%)", zIndex:9999, background: toast.type==="error"?"#ff453a":"#1c1c1e", color:"#fff", borderRadius:24, padding:"11px 20px", fontSize:14, fontWeight:600, boxShadow:"0 8px 32px rgba(0,0,0,0.3)", animation:"fadeIn 0.2s ease", whiteSpace:"nowrap", border:`1px solid ${toast.type==="error"?"#ff453a":"rgba(255,255,255,0.1)"}` }}>{toast.msg}</div>}

        {/* Sidebar */}
        <SidebarNav tab={tab} setTab={setTab} t={t} theme={theme} dark={dark} toggleDark={toggleDark} />

        {/* Main content area — flex:1 makes it fill remaining width, overflow-y scrolls */}
        <div style={{ flex:1, minWidth:0, overflowY:"auto", height:"100vh" }}>
          <div style={{ padding:"32px 36px 60px" }}>
            {tab==="home" && <HomeScreen theme={theme} t={t} query={query} setQuery={setQuery} searching={searching} doSearch={doSearch} results={results} selected={selected} comparing={comparing} comparison={comparison} doCompare={doCompare} rate={rate} vehicle={vehicle} toast_={toast_} clearAll={clearAll} isDesktop={true} searchHistory={searchHistory} isPro={isPro} searchCount={searchCount} setShowUpgrade={setShowUpgrade} countryFilter={countryFilter} setCountryFilter={setCountryFilter} travelProfile={travelProfile} onOpenTravelSetup={() => setShowTravelSetup(true)} />}
            {tab==="settings" && <SettingsScreen theme={theme} t={t} dark={dark} toggleDark={toggleDark} lang={lang} setLang={l=>{setLang(l);localStorage.setItem("cs_lang",l)}} vehicle={vehicle} saveVehicle={saveVehicle} isDesktop={true} />}
          </div>
        </div>
      </div>
    );
  }

  // Mobile layout (unchanged)
  return (
    <div style={{ minHeight:"100vh", background: dark ? "#050508" : "#e8e8ed", fontFamily:"'DM Sans', sans-serif", color:theme.text }}>
      <div style={{ maxWidth:480, margin:"0 auto", background:theme.bg, minHeight:"100vh", position:"relative", boxShadow: "0 0 60px rgba(0,0,0,0.3)", paddingTop:"env(safe-area-inset-top, 0px)" }}>
        <style>{globalStyles}</style>

        {toast && <div style={{ position:"fixed", top:"calc(env(safe-area-inset-top, 0px) + 16px)", left:"50%", transform:"translateX(-50%)", zIndex:9999, background: toast.type==="error"?"#ff453a":"#1c1c1e", color:"#fff", borderRadius:24, padding:"11px 20px", fontSize:14, fontWeight:600, boxShadow:"0 8px 32px rgba(0,0,0,0.3)", animation:"fadeIn 0.2s ease", whiteSpace:"nowrap", border:`1px solid ${toast.type==="error"?"#ff453a":"rgba(255,255,255,0.1)"}` }}>{toast.msg}</div>}

        <div style={{ paddingBottom:88 }}>
          {tab==="home" && <HomeScreen theme={theme} t={t} query={query} setQuery={setQuery} searching={searching} doSearch={doSearch} results={results} selected={selected} comparing={comparing} comparison={comparison} doCompare={doCompare} rate={rate} vehicle={vehicle} toast_={toast_} clearAll={clearAll} isDesktop={false} searchHistory={searchHistory} isPro={isPro} searchCount={searchCount} setShowUpgrade={setShowUpgrade} travelProfile={travelProfile} onOpenTravelSetup={() => setShowTravelSetup(true)} countryFilter={countryFilter} setCountryFilter={setCountryFilter} />}
          {tab==="settings" && <SettingsScreen theme={theme} t={t} dark={dark} toggleDark={toggleDark} lang={lang} setLang={l=>{setLang(l);localStorage.setItem("cs_lang",l)}} vehicle={vehicle} saveVehicle={saveVehicle} isDesktop={false} />}
        </div>

        <BottomNav tab={tab} setTab={setTab} t={t} theme={theme} dark={dark} />

        {showTravelSetup && (
          <TravelSetupModal
            t={t}
            theme={theme}
            initial={travelProfile}
            onSave={(profile) => {
              setTravelProfile(profile);
              localStorage.setItem("cs_travel_profile", JSON.stringify(profile));
              setShowTravelSetup(false);
              toast_("Saved!");
            }}
            onSkip={() => setShowTravelSetup(false)}
          />
        )}

        <Analytics />
      </div>
    </div>
  );
}

function HomeScreen({ theme:th, t, query, setQuery, searching, doSearch, results, selected, comparing, comparison, doCompare, rate, vehicle, toast_, clearAll, isDesktop, searchHistory=[], isPro=false, searchCount=0, setShowUpgrade, travelProfile, onOpenTravelSetup, countryFilter='all', setCountryFilter }) {
  const topPadding = isDesktop ? "0px 0px 16px" : "16px 16px 16px";

  return (
    <div style={{ padding:topPadding, animation:"fadeUp 0.4s ease", width:"100%" }}>
      {/* Header — hide on desktop since sidebar has the logo */}
      {!isDesktop && (
        <div style={{ marginBottom:22 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:2 }}><div style={{ fontSize:30, fontWeight:800, background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", letterSpacing:-1 }}>Cheaperside</div><span style={{fontSize:16}}>🇨🇭🇫🇷🇩🇪</span></div>
          <div style={{ color:th.muted, fontSize:13 }}>{t.tagline}</div>
        </div>
      )}

      {/* Desktop: page title with inline badges */}
      {isDesktop && (
        <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${th.sep}`, display:"flex", alignItems:"flex-start", justifyContent:"space-between" }}>
          <div>
            <h1 style={{ fontSize:28, fontWeight:800, letterSpacing:-0.8, marginBottom:6 }}>{t.tagline}</h1>
            <div style={{ display:"flex", gap:6, alignItems:"center" }}>
              {[{flag:"🇨🇭",label:"CH"},{flag:"🇫🇷",label:"FR"},{flag:"🇩🇪",label:"DE"}].map(c=>(
                <div key={c.label} style={{ display:"flex", alignItems:"center", gap:4, background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"3px 9px", fontSize:11, fontWeight:600, color:th.muted }}>
                  <span style={{fontSize:12}}>{c.flag}</span><span>{c.label}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:4, background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"6px 12px", fontSize:12, color:"#00e5a0", fontWeight:700, flexShrink:0 }}>
            {Icons.zap("#00e5a0")}
            1 CHF = {rate.toFixed(3)} €
          </div>
        </div>
      )}

      {/* Country + rate badges — only show on mobile (desktop has header) */}
      {!isDesktop && (
        <div style={{ display:"flex", gap:6, marginBottom:18, alignItems:"center", flexWrap:"wrap" }}>
          {[{flag:"🇨🇭",label:"CH"},{flag:"🇫🇷",label:"FR"},{flag:"🇩🇪",label:"DE"}].map(c=>(
            <div key={c.label} style={{ display:"flex", alignItems:"center", gap:4, background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"4px 10px", fontSize:11, fontWeight:600, color:th.muted }}>
              <span style={{fontSize:13}}>{c.flag}</span><span>{c.label}</span>
            </div>
          ))}
          <div style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:4, background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"4px 10px", fontSize:11, color:"#00e5a0", fontWeight:700 }}>
            {Icons.zap("#00e5a0")}
            1 CHF = {rate.toFixed(3)} €
          </div>
        </div>
      )}

      {/* Search bar — capped width on desktop */}
      <div style={{ maxWidth: isDesktop ? 680 : "100%" }}>
        <div style={{ background:th.surface, border:`1.5px solid ${query?"#3dffa0":th.border}`, borderRadius:24, padding:"6px 6px 6px 18px", display:"flex", alignItems:"center", gap:8, marginBottom:10, transition:"all 0.25s", boxShadow: query ? "0 0 0 4px rgba(61,255,160,0.08)" : "none" }}>
          <span style={{color:th.muted,flexShrink:0}}>{Icons.search(th.muted)}</span>
          <input value={query} onChange={e=>setQuery(e.target.value)} onKeyDown={e=>e.key==="Enter"&&doSearch()} placeholder={t.searchPlaceholder} style={{ flex:1, background:"transparent", border:"none", color:th.text, fontSize: isDesktop ? 17 : 16, fontFamily:"'DM Sans', sans-serif", padding:"12px 0" }} />
          {query && <button onClick={clearAll} style={{ background:th.surface2, border:"none", borderRadius:8, padding:"4px", display:"flex", alignItems:"center" }}>{Icons.close(th.muted)}</button>}
          <button onClick={doSearch} disabled={!query.trim()} style={{ background: query.trim()?"linear-gradient(135deg,#3dffa0,#5b8fff)":th.surface2, border:"none", borderRadius:20, padding:"11px 22px", color: query.trim()?"#0d0d1a":th.muted, fontWeight:800, fontSize:14, transition:"all 0.2s", flexShrink:0, letterSpacing:"-0.3px" }}>Go</button>
        </div>
        <button onClick={() => {
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({ type: "SCAN_BARCODE" }));
            } else {
              toast_("Barcode scanner available in the mobile app");
            }
          }}
          style={{ width:"100%", background:th.surface, border:`1.5px dashed ${th.border}`, borderRadius:18, padding:"13px", color:th.muted, fontSize:13, fontWeight:600, display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginBottom:22, transition:"all 0.2s" }}
          onMouseEnter={e=>e.currentTarget.style.borderColor="#00e5a0"} onMouseLeave={e=>e.currentTarget.style.borderColor=th.border}>
          {Icons.scan(th.muted)}{t.scan}
        </button>
      </div>

      {searching && <div style={{textAlign:"center",padding:"40px 0"}}><Spinner/><p style={{color:th.muted,fontSize:14,marginTop:14}}>{t.searching}</p></div>}

      {results && !searching && !comparison && (
        <div style={{animation:"fadeUp 0.3s ease"}}>
          {/* Country filter tabs */}
          {results.length > 0 && (
            <div style={{ display:"flex", gap:6, marginBottom:14, overflowX:"auto" }}>
              {[
                { key:'all', label:'All', flag:'' },
                { key:'CH', label:'CH', flag:'🇨🇭' },
                { key:'FR', label:'FR', flag:'🇫🇷' },
                { key:'DE', label:'DE', flag:'🇩🇪' },
                { key:'EU', label:'EU', flag:'🇪🇺' },
              ].map(f => {
                const count = f.key === 'all' ? results.length : results.filter(r => r.country === f.key).length;
                if (f.key !== 'all' && count === 0) return null;
                const active = countryFilter === f.key;
                return (
                  <button key={f.key} onClick={() => setCountryFilter(f.key)}
                    style={{ display:"flex", alignItems:"center", gap:5, padding:"7px 14px", borderRadius:12,
                      background: active ? "rgba(0,229,160,0.15)" : th.surface,
                      border: `1.5px solid ${active ? "rgba(0,229,160,0.4)" : th.border}`,
                      color: active ? "#00e5a0" : th.muted, fontSize:13, fontWeight:600, cursor:"pointer",
                      whiteSpace:"nowrap", transition:"all 0.15s" }}>
                    {f.flag && <span>{f.flag}</span>}{f.label} <span style={{fontSize:11,opacity:0.7}}>({count})</span>
                  </button>
                );
              })}
            </div>
          )}

          {/* Results count */}
          {(() => {
            const filtered = countryFilter === 'all' ? results : results.filter(r => r.country === countryFilter);
            const eurToChf = 1 / (rate || 0.95);
            return (
              <>
                <p style={{ color:th.muted, fontSize:11, fontWeight:700, letterSpacing:0.8, textTransform:"uppercase", marginBottom:12 }}>
                  {filtered.length > 0 ? `${filtered.length} products found` : t.noResults}
                </p>

                {/* Results grid */}
                <div style={{ display: isDesktop ? "grid" : "flex", gridTemplateColumns: isDesktop ? "1fr 1fr" : undefined, flexDirection: isDesktop ? undefined : "column", gap:10 }}>
                  {filtered.length===0
                    ? <div style={{textAlign:"center",padding:32,color:th.muted,gridColumn:"1/-1"}}><div style={{fontSize:36,marginBottom:8}}>🔍</div><p>{t.noResults}</p></div>
                    : filtered.map((item,i)=>{
                      // CHF conversion for non-CHF prices
                      const priceChf = item.priceNum
                        ? (item.currency === 'CHF' ? item.priceNum : Math.round(item.priceNum * eurToChf))
                        : null;
                      // Border cost estimate for non-CH products
                      const isForeign = item.country && item.country !== 'CH';
                      const showBorderCost = isForeign && priceChf && travelProfile;
                      let borderTotal = null;
                      let fuelEst = null;
                      let vatEst = null;
                      if (showBorderCost) {
                        const country = item.country === 'FR' ? 'fr' : item.country === 'DE' ? 'de' : null;
                        if (country) {
                          const dist = (DISTANCES[travelProfile.city] || DISTANCES.Other)[country] || 100;
                          const roundTrip = dist * 2;
                          const cons = travelProfile.consumption || DEFAULT_CONSUMPTION[travelProfile.vehicleType] || 7.5;
                          const fuelPrice = FUEL_PRICES[travelProfile.vehicleType] || FUEL_PRICES.petrol;
                          fuelEst = Math.round((roundTrip * cons / 100) * fuelPrice);
                          vatEst = priceChf > 150 ? Math.round(priceChf * 0.081) : 0;
                          borderTotal = priceChf + fuelEst + vatEst;
                        }
                      }

                      return (
                        <a key={i} href={item.clickUrl} target="_blank" rel="noopener noreferrer"
                          style={{ display:"flex", alignItems:"center", gap:12, background:th.surface, border:`1.5px solid ${th.border}`, borderRadius:18, padding:"13px 14px", textAlign:"left", color:th.text, transition:"all 0.2s", textDecoration:"none", cursor:"pointer" }}
                          onMouseEnter={e=>{e.currentTarget.style.borderColor="#00e5a0";e.currentTarget.style.transform="translateY(-1px)"}}
                          onMouseLeave={e=>{e.currentTarget.style.borderColor=th.border;e.currentTarget.style.transform="translateY(0)"}}>
                          {item.thumbnail
                            ? <img src={item.thumbnail} alt="" style={{width:50,height:50,borderRadius:10,objectFit:"contain",background:"#fff",flexShrink:0}}/>
                            : <div style={{width:50,height:50,borderRadius:10,background:th.surface2,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>📦</div>}
                          <div style={{flex:1,minWidth:0}}>
                            <p style={{fontSize:13,fontWeight:600,lineHeight:1.3,overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:4}}>{item.title}</p>
                            <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                              {item.price && <p style={{fontSize:15,fontWeight:700,color:"#00e5a0",margin:0}}>{item.price}</p>}
                              {item.priceOld > 0 && item.priceOld > item.priceNum && <p style={{fontSize:12,color:th.muted,textDecoration:"line-through",margin:0}}>{item.priceOld}{item.currency === 'EUR' ? ' €' : item.currency === 'GBP' ? ' £' : ''}</p>}
                              {item.discount > 0 && <span style={{fontSize:10,fontWeight:700,background:"rgba(0,229,160,0.15)",color:"#00e5a0",padding:"2px 6px",borderRadius:6}}>-{item.discount}%</span>}
                            </div>
                            {/* CHF conversion + border costs */}
                            {priceChf && item.currency !== 'CHF' && (
                              <p style={{fontSize:11,color:"#5b8fff",marginTop:3}}>
                                ≈ CHF {priceChf}
                                {borderTotal && <span style={{color:th.muted}}> · real cost CHF {borderTotal} <span style={{fontSize:9}}>(+{fuelEst} fuel{vatEst > 0 ? ` +${vatEst} VAT` : ''})</span></span>}
                              </p>
                            )}
                            {priceChf && item.currency !== 'CHF' && !travelProfile && isForeign && (
                              <p style={{fontSize:10,color:th.muted,marginTop:2,cursor:"pointer"}} onClick={(e)=>{e.preventDefault();e.stopPropagation();onOpenTravelSetup&&onOpenTravelSetup()}}>
                                ⚙️ Set location for fuel + customs estimate
                              </p>
                            )}
                            <p style={{fontSize:11,color:th.muted,marginTop:3}}>
                              {item.source}{item.country ? ` · ${item.country === 'CH' ? '🇨🇭' : item.country === 'FR' ? '🇫🇷' : item.country === 'DE' ? '🇩🇪' : '🇪🇺'} ${item.country}` : ''}
                            </p>
                          </div>
                          <span style={{color:"#00e5a0",flexShrink:0,fontSize:11,fontWeight:600}}>Buy →</span>
                        </a>
                      );
                    })
                  }
                </div>

                {/* Customs reminder */}
                {filtered.some(r => r.country && r.country !== 'CH') && (
                  <div style={{ marginTop:12, padding:"10px 14px", background:"rgba(0,229,160,0.06)", border:"1px solid rgba(0,229,160,0.15)", borderRadius:12 }}>
                    <p style={{fontSize:11,color:"#00e5a0",fontWeight:600}}>🛃 {t.customsLimit}</p>
                  </div>
                )}
              </>
            );
          })()}
        </div>
      )}

      {comparing && <div style={{textAlign:"center",padding:"40px 0"}}><Spinner/><p style={{color:th.muted,fontSize:14,marginTop:14}}>Checking prices in CH, FR & DE...</p></div>}

      {comparison && selected && !comparing && <ComparisonView comparison={comparison} product={selected} th={th} t={t} vehicle={vehicle} rate={rate} onBack={clearAll} isDesktop={isDesktop} travelProfile={travelProfile} onOpenTravelSetup={onOpenTravelSetup} />}

      {!results && !searching && !comparison && !comparing && (
        isDesktop ? (
          <div style={{ marginTop:8 }}>
            {/* Popular searches */}
            <div style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"16px 18px", marginBottom:12 }}>
              <p style={{ fontSize:11, fontWeight:700, color:th.muted, textTransform:"uppercase", letterSpacing:0.8, marginBottom:10 }}>Try searching</p>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {['Robot vacuum', 'Headphones', 'Speakers', 'Security camera', 'Smart scale', 'Earbuds', 'Doorbell', 'OnePlus phone'].map((term, i) => (
                  <button key={i} onClick={() => { setQuery(term); setTimeout(doSearch, 0); }}
                    style={{ background:"rgba(0,229,160,0.08)", border:"1px solid rgba(0,229,160,0.2)", borderRadius:20, padding:"6px 14px", fontSize:12, fontWeight:600, color:"#00e5a0", cursor:"pointer", transition:"all 0.15s" }}
                    onMouseEnter={e => { e.currentTarget.style.background="rgba(0,229,160,0.15)"; e.currentTarget.style.borderColor="rgba(0,229,160,0.4)"; }}
                    onMouseLeave={e => { e.currentTarget.style.background="rgba(0,229,160,0.08)"; e.currentTarget.style.borderColor="rgba(0,229,160,0.2)"; }}>
                    {term}
                  </button>
                ))}
              </div>
            </div>
            {/* Recent searches */}
            {searchHistory.length > 0 && (
              <div style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"16px 18px", marginBottom:12 }}>
                <p style={{ fontSize:11, fontWeight:700, color:th.muted, textTransform:"uppercase", letterSpacing:0.8, marginBottom:10 }}>Recent searches</p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  {searchHistory.map((h, i) => (
                    <button key={i} onClick={() => { setQuery(h); setTimeout(doSearch, 0); }}
                      style={{ background:th.surface2, border:`1px solid ${th.border}`, borderRadius:20, padding:"6px 12px", fontSize:12, fontWeight:600, color:th.muted, cursor:"pointer", transition:"all 0.15s" }}
                      onMouseEnter={e => { e.currentTarget.style.borderColor="#00e5a0"; e.currentTarget.style.color="#00e5a0"; }}
                      onMouseLeave={e => { e.currentTarget.style.borderColor=th.border; e.currentTarget.style.color=th.muted; }}>
                      {h}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {/* Desktop: 2-col layout — info left, how-it-works right */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
              {/* Left col: key facts */}
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                <p style={{ fontSize:11, fontWeight:700, color:th.muted, textTransform:"uppercase", letterSpacing:0.8, marginBottom:4 }}>What we do</p>
                {[
                  { icon: Icons.info("#00e5a0"), text: t.customsLimit },
                  { icon: Icons.fuel("#00b8ff"), text: vehicle.type==="electric" ? "⚡ Electric vehicle — no fuel costs added" : `${vehicle.type.charAt(0).toUpperCase()+vehicle.type.slice(1)} · ${vehicle.consumption}L/100km — fuel cost included` },
                  { icon: <span style={{fontSize:15}}>🛒</span>, text: "Prices from Eufy, Teufel, OnePlus & more retailers coming soon" },
                ].map((item,i)=>(
                  <div key={i} style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:14, padding:"12px 14px", display:"flex", gap:10, alignItems:"center" }}>
                    <div style={{flexShrink:0}}>{item.icon}</div>
                    <p style={{fontSize:13,color:th.muted,lineHeight:1.5}}>{item.text}</p>
                  </div>
                ))}
              </div>
              {/* Right col: how it works steps */}
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                <p style={{ fontSize:11, fontWeight:700, color:th.muted, textTransform:"uppercase", letterSpacing:0.8, marginBottom:4 }}>How it works</p>
                {[
                  { step:"1", title:"Search a product", desc:"Type any product name — phone, appliance, toy, anything." },
                  { step:"2", title:"Pick the best match", desc:"Choose from real results across CH, FR & DE stores." },
                  { step:"3", title:"See your savings", desc:"We add fuel cost and show you exactly where to buy." },
                ].map((item,i)=>(
                  <div key={i} style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:14, padding:"12px 14px", display:"flex", gap:12, alignItems:"flex-start" }}>
                    <div style={{ width:24, height:24, borderRadius:12, background:"rgba(0,229,160,0.12)", border:"1px solid rgba(0,229,160,0.3)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:11, fontWeight:800, color:"#00e5a0" }}>{item.step}</div>
                    <div>
                      <p style={{fontSize:13,fontWeight:700,marginBottom:2}}>{item.title}</p>
                      <p style={{fontSize:12,color:th.muted,lineHeight:1.5}}>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Bottom: popular searches */}
            <div style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"16px 18px" }}>
              <p style={{ fontSize:11, fontWeight:700, color:th.muted, textTransform:"uppercase", letterSpacing:0.8, marginBottom:10 }}>Try searching for</p>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {["Robot vacuum","Headphones","Speakers","Security camera","Smart scale","Earbuds","Doorbell","OnePlus phone"].map(s=>(
                  <button key={s} onClick={()=>{setQuery(s);setTimeout(doSearch,0);}} style={{ background:"rgba(0,229,160,0.08)", border:"1px solid rgba(0,229,160,0.2)", borderRadius:20, padding:"6px 14px", fontSize:12, fontWeight:600, color:"#00e5a0", cursor:"pointer", transition:"all 0.15s" }}
                    onMouseEnter={e=>{e.currentTarget.style.background="rgba(0,229,160,0.15)";e.currentTarget.style.borderColor="rgba(0,229,160,0.4)"}}
                    onMouseLeave={e=>{e.currentTarget.style.background="rgba(0,229,160,0.08)";e.currentTarget.style.borderColor="rgba(0,229,160,0.2)"}}>
                    {s}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {/* Popular searches */}
            <div style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"16px 18px" }}>
              <p style={{ fontSize:11, fontWeight:700, color:th.muted, textTransform:"uppercase", letterSpacing:0.8, marginBottom:10 }}>Try searching</p>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {['Robot vacuum', 'Headphones', 'Speakers', 'Security camera', 'Earbuds', 'Doorbell'].map((term, i) => (
                  <button key={i} onClick={() => { setQuery(term); setTimeout(doSearch, 0); }}
                    style={{ background:"rgba(0,229,160,0.08)", border:"1px solid rgba(0,229,160,0.2)", borderRadius:20, padding:"6px 14px", fontSize:12, fontWeight:600, color:"#00e5a0", cursor:"pointer", transition:"all 0.15s" }}>
                    {term}
                  </button>
                ))}
              </div>
            </div>
            {searchHistory.length > 0 && (
              <div style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:20, padding:"16px 18px" }}>
                <p style={{ fontSize:11, fontWeight:700, color:th.muted, textTransform:"uppercase", letterSpacing:0.8, marginBottom:10 }}>Recent searches</p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  {searchHistory.map((h, i) => (
                    <button key={i} onClick={() => { setQuery(h); doSearch(); }}
                      style={{ background:th.surface2, border:`1px solid ${th.border}`, borderRadius:20, padding:"6px 12px", fontSize:12, fontWeight:600, color:th.muted, cursor:"pointer" }}>
                      {h}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {[
              { icon: Icons.info("#00e5a0"), text: t.customsLimit },
              { icon: Icons.fuel("#00b8ff"), text: vehicle.type==="electric" ? "⚡ Electric vehicle — no fuel costs added" : `${vehicle.type.charAt(0).toUpperCase()+vehicle.type.slice(1)} · ${vehicle.consumption}L/100km — fuel cost included` },
              { icon: <span style={{fontSize:16}}>🛒</span>, text: "Compares prices from Eufy, Teufel, OnePlus and more retailers coming soon" },
            ].map((item,i)=>(
              <div key={i} style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:16, padding:"14px 16px", display:"flex", gap:12, alignItems:"flex-start" }}>
                <div style={{flexShrink:0,marginTop:1}}>{item.icon}</div>
                <p style={{fontSize:13,color:th.muted,lineHeight:1.6}}>{item.text}</p>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
}

function TravelSetupModal({ t, theme: th, initial, onSave, onSkip }) {
  const cities = ['Basel', 'Geneva', 'Zurich', 'Lausanne', 'Bern', 'Lucerne', 'StGallen', 'Schaffhausen', 'Lugano', 'Sion', 'Other'];
  const [city, setCity] = useState(initial?.city || 'Basel');
  const [vehicleType, setVehicleType] = useState(initial?.vehicleType || 'petrol');
  const [consumption, setConsumption] = useState(initial?.consumption || DEFAULT_CONSUMPTION[initial?.vehicleType || 'petrol']);

  // When vehicle type changes, update default consumption (unless user already changed it)
  useEffect(() => {
    setConsumption(DEFAULT_CONSUMPTION[vehicleType]);
  }, [vehicleType]);

  const handleSave = () => onSave({ city, vehicleType, consumption });

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 10000,
      display: "flex", alignItems: "flex-end", justifyContent: "center",
      animation: "fadeIn 0.2s ease",
    }}>
      <div style={{
        background: th.bg, width: "100%", maxWidth: 480, borderRadius: "20px 20px 0 0",
        padding: 22, paddingBottom: 32, animation: "fadeUp 0.3s ease",
      }}>
        <div style={{ width: 40, height: 4, background: th.border, borderRadius: 2, margin: "0 auto 16px" }} />

        <h2 style={{ fontSize: 20, fontWeight: 800, color: th.text, marginBottom: 6 }}>
          🚗 {t.verdictSetupTitle}
        </h2>
        <p style={{ fontSize: 13, color: th.muted, lineHeight: 1.5, marginBottom: 18 }}>
          {t.verdictSetupSub}
        </p>

        {/* City */}
        <p style={{ fontSize: 12, fontWeight: 700, color: th.muted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>
          {t.verdictSetupCity}
        </p>
        <select
          value={city}
          onChange={(e) => setCity(e.target.value)}
          style={{
            width: "100%", padding: "12px 14px", fontSize: 15, color: th.text,
            background: th.surface, border: `1px solid ${th.border}`, borderRadius: 12,
            marginBottom: 16, fontFamily: "inherit", appearance: "none",
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2'><polyline points='6 9 12 15 18 9'/></svg>")`,
            backgroundRepeat: "no-repeat", backgroundPosition: "right 14px center",
          }}
        >
          {cities.map(c => <option key={c} value={c}>{c === 'StGallen' ? 'St. Gallen' : c}</option>)}
        </select>

        {/* Vehicle */}
        <p style={{ fontSize: 12, fontWeight: 700, color: th.muted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>
          {t.verdictSetupVehicle}
        </p>
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          {[
            { id: 'petrol', label: `⛽ ${t.petrol}` },
            { id: 'diesel', label: `🛢️ ${t.diesel}` },
            { id: 'electric', label: `⚡ ${t.electric}` },
          ].map(v => (
            <button
              key={v.id}
              onClick={() => setVehicleType(v.id)}
              style={{
                flex: 1, padding: "12px 8px", fontSize: 13, fontWeight: 600,
                background: vehicleType === v.id ? "rgba(0,229,160,0.15)" : th.surface,
                border: `1.5px solid ${vehicleType === v.id ? "#3dffa0" : th.border}`,
                borderRadius: 12, color: vehicleType === v.id ? "#3dffa0" : th.text,
                cursor: "pointer",
              }}
            >
              {v.label}
            </button>
          ))}
        </div>

        {/* Consumption (hide for electric) */}
        {vehicleType !== 'electric' && (
          <>
            <p style={{ fontSize: 12, fontWeight: 700, color: th.muted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>
              {t.verdictSetupConsumption}
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
              <input
                type="range" min="3" max="15" step="0.5"
                value={consumption}
                onChange={(e) => setConsumption(parseFloat(e.target.value))}
                style={{ flex: 1, accentColor: "#3dffa0" }}
              />
              <span style={{ fontSize: 16, fontWeight: 700, color: th.text, minWidth: 60, textAlign: "right" }}>
                {consumption} L
              </span>
            </div>
            <p style={{ fontSize: 11, color: th.muted, marginBottom: 18 }}>
              Default: {DEFAULT_CONSUMPTION[vehicleType]} L/100km. Adjust if you know yours.
            </p>
          </>
        )}

        {/* Buttons */}
        <button
          onClick={handleSave}
          style={{
            width: "100%", padding: 14, fontSize: 15, fontWeight: 800,
            background: "linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)",
            border: "none", borderRadius: 14, color: "#000", cursor: "pointer",
            marginBottom: 8,
          }}
        >
          {t.verdictSetupSave}
        </button>
        <button
          onClick={onSkip}
          style={{
            width: "100%", padding: 12, fontSize: 13, fontWeight: 600,
            background: "transparent", border: "none", color: th.muted, cursor: "pointer",
          }}
        >
          {t.verdictSetupSkip}
        </button>
      </div>
    </div>
  );
}

function VerdictCard({ v, th, t }) {
  // Color by verdict type
  const palette = {
    worth_it:   { bg: "rgba(61,255,160,0.10)", border: "#3dffa0", text: "#3dffa0", emoji: "✅" },
    borderline: { bg: "rgba(255,179,0,0.10)",  border: "#ffb300", text: "#ffb300", emoji: "⚠️" },
    not_worth:  { bg: "rgba(255,69,58,0.08)",  border: "#ff453a", text: "#ff453a", emoji: "❌" },
  };
  const p = palette[v.verdict];

  const headlineByVerdict = {
    worth_it: `${t.verdictWorthIt} ${v.countryName}`,
    borderline: `${t.verdictBorderline} — ${v.countryName}`,
    not_worth: t.verdictNotWorth,
  };

  return (
    <div style={{ background: p.bg, border: `1.5px solid ${p.border}`, borderRadius: 18, padding: 14, marginBottom: 14 }}>
      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom: 10 }}>
        <span style={{ fontSize: 18 }}>{p.emoji}</span>
        <p style={{ fontWeight: 800, fontSize: 14, color: p.text }}>{headlineByVerdict[v.verdict]}</p>
      </div>

      {v.verdict !== 'not_worth' && (
        <div style={{ marginBottom: 10 }}>
          <p style={{ fontSize: 22, fontWeight: 800, color: p.text, lineHeight: 1, marginBottom: 4 }}>
            {t.verdictYouSave} CHF {v.savingsChf}
          </p>
          <p style={{ fontSize: 11, color: th.muted }}>{t.verdictAfterCosts}</p>
        </div>
      )}
      {v.verdict === 'not_worth' && (
        <div style={{ marginBottom: 10 }}>
          <p style={{ fontSize: 14, fontWeight: 700, color: th.text, lineHeight: 1.4 }}>
            {v.savingsChf >= 0
              ? `Only saves ~CHF ${v.savingsChf} after fuel & VAT — not worth the trip.`
              : `Costs ~CHF ${Math.abs(v.savingsChf)} more after fuel & VAT.`}
          </p>
        </div>
      )}

      {/* Breakdown */}
      <div style={{ background: "rgba(0,0,0,0.15)", borderRadius: 10, padding: 10, fontSize: 11.5, color: th.text, lineHeight: 1.7 }}>
        <div style={{ display:"flex", justifyContent:"space-between" }}>
          <span style={{ color: th.muted }}>{v.foreignCountry === 'de' ? 'Germany' : 'France'}: {v.foreignPrice} €</span>
          <span>≈ CHF {v.foreignPriceChf}</span>
        </div>
        {v.overAllowance && (
          <div style={{ display:"flex", justifyContent:"space-between" }}>
            <span style={{ color: th.muted }}>+ {t.verdictSwissVat}</span>
            <span>CHF {v.swissVatChf}</span>
          </div>
        )}
        <div style={{ display:"flex", justifyContent:"space-between" }}>
          <span style={{ color: th.muted }}>+ {t.verdictFuel} ({v.roundTripKm}km {t.verdictRoundTrip.toLowerCase()})</span>
          <span>CHF {v.fuelCostChf}</span>
        </div>
        <div style={{ display:"flex", justifyContent:"space-between", marginTop: 4, paddingTop: 4, borderTop: `1px solid ${th.border}`, fontWeight: 700 }}>
          <span>Total cost</span>
          <span>CHF {v.crossingTotalChf}</span>
        </div>
        <div style={{ display:"flex", justifyContent:"space-between", color: th.muted, marginTop: 2 }}>
          <span>vs Switzerland</span>
          <span>CHF {v.swissPriceChf}</span>
        </div>
      </div>

      {v.overAllowance && (
        <p style={{ fontSize: 11, color: th.muted, marginTop: 8, lineHeight: 1.4 }}>
          ℹ️ {t.verdictAboveAllowance}
        </p>
      )}

      {v.canTaxFreeRefund && v.verdict !== 'not_worth' && (
        <p style={{ fontSize: 11, color: th.muted, marginTop: 8, lineHeight: 1.4 }}>
          💡 {t.verdictTaxFreeNudge}{' '}
          <a href="/tax-free-refund.html" target="_blank" rel="noopener" style={{ color: "#3dffa0", textDecoration: "underline" }}>{t.verdictLearnMore}</a>
        </p>
      )}

      <p style={{ fontSize: 10, color: th.muted, marginTop: 10, fontStyle: "italic", lineHeight: 1.4 }}>
        {t.verdictDisclaimer}
      </p>
    </div>
  );
}

function ComparisonView({ comparison, product, th, t, vehicle, rate, onBack, isDesktop, travelProfile, onOpenTravelSetup }) {
  // Build clean retailer cards with real prices
  const countries = [
    { key: 'ch', name: t.ch, flag: '🇨🇭', items: comparison.ch || [] },
    { key: 'fr', name: t.fr, flag: '🇫🇷', items: comparison.fr || [] },
    { key: 'de', name: t.de, flag: '🇩🇪', items: comparison.de || [] },
  ];

  const totalLinks = countries.reduce((sum, c) => sum + c.items.filter(i => i.url && i.price > 0).length, 0);

  // Find the cheapest in CHF-equivalent (rate is EUR→CHF)
  const eurToChf = rate || 0.95;
  const allPriced = countries.flatMap(c => c.items).filter(i => i.price > 0);
  // Helper to detect refurbished items
  const isRefurbItem = (item) => /reconditionn|refurbish|refurb|gebraucht|ricondizionat/i.test(item.title || '');
  // Best deal should ideally be a NEW item; only fall back to refurb if no new items
  const newItems = allPriced.filter(i => !isRefurbItem(i));
  const itemsForBest = newItems.length > 0 ? newItems : allPriced;
  const cheapestPrice = itemsForBest.length > 0
    ? Math.min(...itemsForBest.map(i => i.currency === 'CHF' ? i.price : i.price * eurToChf))
    : null;
  // For display purposes, mark the actual lowest local price per country, not converted
  const cheapestLocalByCountry = {};
  countries.forEach(c => {
    const priced = c.items.filter(i => i.price > 0);
    if (priced.length > 0) cheapestLocalByCountry[c.key] = Math.min(...priced.map(i => i.price));
  });

  // Cross-border verdict math (only if we have BOTH a Swiss price AND at least one foreign price)
  // and the user has set up their travel profile
  const swissPriceChf = cheapestLocalByCountry.ch || null;
  const verdicts = [];
  if (swissPriceChf && travelProfile) {
    if (cheapestLocalByCountry.de) {
      const v = calculateVerdict({
        swissPriceChf,
        foreignPrice: cheapestLocalByCountry.de,
        foreignCountry: 'de',
        exchangeRate: rate,
        profile: travelProfile,
      });
      if (v) verdicts.push({ ...v, countryName: t.de });
    }
    if (cheapestLocalByCountry.fr) {
      const v = calculateVerdict({
        swissPriceChf,
        foreignPrice: cheapestLocalByCountry.fr,
        foreignCountry: 'fr',
        exchangeRate: rate,
        profile: travelProfile,
      });
      if (v) verdicts.push({ ...v, countryName: t.fr });
    }
    // Sort: best deal first
    verdicts.sort((a, b) => b.savingsChf - a.savingsChf);
  }
  const showNoSwissPriceWarning = travelProfile
    && !swissPriceChf
    && (cheapestLocalByCountry.fr || cheapestLocalByCountry.de);

  return (
    <div style={{animation:"fadeUp 0.3s ease"}}>
      <button onClick={onBack} style={{ display:"flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:"#00e5a0", fontSize:14, fontWeight:600, marginBottom:14, padding:0 }}>
        {Icons.back("#00e5a0")}{t.back}
      </button>

      {/* Product header */}
      <div style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:16, padding:"12px 14px", marginBottom:14, display:"flex", gap:10, alignItems:"center" }}>
        {product.thumbnail
          ? <img src={product.thumbnail} alt="" style={{width:40,height:40,borderRadius:8,objectFit:"contain",background:"#fff",flexShrink:0}}/>
          : <div style={{width:40,height:40,borderRadius:8,background:th.surface2,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>📦</div>}
        <p style={{fontSize:13,fontWeight:600,lineHeight:1.3,overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>{product.title}</p>
      </div>

      {/* Intro card */}
      <div style={{ background:"linear-gradient(135deg,rgba(0,229,160,0.10),rgba(91,143,255,0.10))", border:"1.5px solid rgba(0,229,160,0.25)", borderRadius:18, padding:14, marginBottom:14 }}>
        <p style={{fontSize:11,color:"#00e5a0",fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:6}}>{t.checkRetailers}</p>
        <p style={{fontSize:13,color:th.text,lineHeight:1.5}}>{t.checkRetailersText}</p>
      </div>

      {/* Cross-border verdict cards */}
      {verdicts.map((v, idx) => <VerdictCard key={idx} v={v} th={th} t={t} />)}

      {/* Prompt to set up travel profile if missing but we have prices to compare */}
      {!travelProfile && swissPriceChf && (cheapestLocalByCountry.fr || cheapestLocalByCountry.de) && (
        <button onClick={onOpenTravelSetup} style={{
          width: "100%", background: "rgba(91,143,255,0.10)", border: "1.5px dashed rgba(91,143,255,0.4)",
          borderRadius: 14, padding: "14px 16px", marginBottom: 14, cursor: "pointer",
          textAlign: "left", color: th.text, fontFamily: "inherit",
        }}>
          <p style={{ fontSize: 13, fontWeight: 700, color: "#5b8fff", marginBottom: 4 }}>
            🚗 Is it worth crossing the border?
          </p>
          <p style={{ fontSize: 11.5, color: th.muted, lineHeight: 1.5 }}>
            Tap to set up your travel basics — we'll calculate fuel and customs costs to tell you if it's actually cheaper.
          </p>
        </button>
      )}

      {showNoSwissPriceWarning && (
        <div style={{ background:"rgba(255,179,0,0.08)", border:"1px solid rgba(255,179,0,0.25)", borderRadius:14, padding:12, marginBottom:14, fontSize:12, color:th.text, lineHeight:1.5 }}>
          ⚠️ {t.verdictNoSwissPrice}
        </div>
      )}

      {totalLinks === 0 && (
        <div style={{ textAlign:"center", padding:"32px 16px", background:th.surface, border:`1px solid ${th.border}`, borderRadius:18, marginBottom:14 }}>
          <div style={{fontSize:36,marginBottom:12}}>🔍</div>
          <p style={{color:th.text,fontWeight:600,marginBottom:6}}>{t.noResults}</p>
          <p style={{color:th.muted,fontSize:13}}>{t.tryDifferentTerm}</p>
        </div>
      )}

      {/* Country sections */}
      <div style={{ display: isDesktop ? "grid" : "flex", gridTemplateColumns: isDesktop ? "1fr 1fr 1fr" : undefined, flexDirection: isDesktop ? undefined : "column", gap:12, marginBottom:14 }}>
        {countries.map(country => {
          const validItems = country.items.filter(i => i.url && i.price > 0);
          // Hide CH section when we have no Swiss scrapers (handled by warning above);
          // for FR/DE, always show the section so user knows they were searched
          if (validItems.length === 0 && country.key === 'ch') return null;
          if (validItems.length === 0) {
            return (
              <div key={country.key} style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:18, padding:16, marginBottom:14, opacity:0.6 }}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
                  <span style={{fontSize:24}}>{country.flag}</span>
                  <div>
                    <p style={{fontSize:16,fontWeight:800}}>{country.name}</p>
                    <p style={{fontSize:11,color:th.muted}}>No results found for this query</p>
                  </div>
                </div>
              </div>
            );
          }
          return (
            <div key={country.key} style={{ background:th.surface, border:`1.5px solid ${th.border}`, borderRadius:20, padding:"16px 18px" }}>
              {/* Country header */}
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12,paddingBottom:10,borderBottom:`1px solid ${th.sep}`}}>
                <span style={{fontSize:28}}>{country.flag}</span>
                <div>
                  <p style={{fontWeight:700,fontSize:16}}>{country.name}</p>
                  <p style={{fontSize:11,color:th.muted}}>{validItems.length} {validItems.length === 1 ? t.retailer : t.retailers}</p>
                </div>
              </div>

              {/* Retailer buttons with real prices */}
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {validItems.map((item, i) => {
                  const itemInChf = item.currency === 'CHF' ? item.price : item.price * eurToChf;
                  const titleLower = (item.title || '').toLowerCase();
                  const isRefurb = /reconditionn|refurbish|refurb|gebraucht|ricondizionat/i.test(titleLower);
                  // An item is the best deal only if (a) its price matches cheapestPrice AND
                  // (b) it's not refurb when other new items exist
                  const isCheapest = cheapestPrice
                    && Math.abs(itemInChf - cheapestPrice) < 0.5
                    && (!isRefurb || newItems.length === 0);
                  return (
                    <a key={i} href={item.url} target="_blank" rel="noopener noreferrer"
                      style={{ display:"flex", alignItems:"center", justifyContent:"space-between", background:isCheapest ? "rgba(61,255,160,0.08)" : th.surface2, border:`1px solid ${isCheapest ? "#3dffa0" : th.border}`, borderRadius:12, padding:"12px 14px", textDecoration:"none", color:th.text, transition:"all 0.2s" }}>
                      <div style={{flex:1,minWidth:0}}>
                        <p style={{fontSize:13,fontWeight:700,marginBottom:2,display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                          {item.source}
                          {isCheapest && <span style={{fontSize:9,fontWeight:700,background:"#3dffa0",color:"#000",padding:"2px 6px",borderRadius:4}}>{t.bestDeal || "BEST"}</span>}
                          {isRefurb && <span style={{fontSize:9,fontWeight:700,background:"rgba(255,179,0,0.2)",color:"#ffb300",padding:"2px 6px",borderRadius:4,border:"1px solid rgba(255,179,0,0.4)"}}>REFURB</span>}
                        </p>
                        <p style={{fontSize:10,color:th.muted,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:"100%"}} title={item.title}>{(item.title && item.title.length > 50 ? item.title.substring(0, 50) + '…' : item.title) || t.viewProduct} →</p>
                      </div>
                      <div style={{ textAlign:"right", flexShrink:0, marginLeft:10 }}>
                        <p style={{fontSize:16,fontWeight:800,color:isCheapest ? "#3dffa0" : th.text,lineHeight:1}}>
                          {item.currency === 'CHF' ? 'CHF ' : ''}{Math.round(item.price)}{item.currency === 'EUR' ? ' €' : ''}
                        </p>
                        <p style={{fontSize:9,color:th.muted,marginTop:3}}>{t.openSite}</p>
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      {/* Customs info */}
      <div style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:14, padding:"12px 14px", display:"flex", gap:10, alignItems:"flex-start" }}>
        {Icons.info(th.muted)}
        <p style={{fontSize:11,color:th.muted,lineHeight:1.6}}>
          💡 <strong style={{color:th.text}}>{t.crossBorderTips}:</strong> {t.crossBorderTipsText}
        </p>
      </div>

      {/* Affiliate disclosure */}
      <div style={{ background:th.surface, border:`1px solid ${th.border}`, borderRadius:14, padding:"12px 14px", marginTop:10, display:"flex", gap:10, alignItems:"flex-start" }}>
        <div style={{fontSize:14, lineHeight:1, marginTop:1}}>🔗</div>
        <p style={{fontSize:10,color:th.muted,lineHeight:1.6}}>
          <strong style={{color:th.text}}>{t.affiliateNotice}:</strong> {t.affiliateText}
        </p>
      </div>
    </div>
  );
}

function SettingsScreen({ theme:th, t, dark, toggleDark, lang, setLang, vehicle, saveVehicle, isDesktop }) {
  const [lv, setLv] = useState(vehicle);

  return (
    <div style={{ padding: isDesktop ? "0px 0px 16px" : "16px 16px 40px", animation:"fadeUp 0.4s ease", width:"100%", boxSizing:"border-box" }}>
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:24 }}>
        <div style={{fontSize:isDesktop?32:28,fontWeight:800,letterSpacing:-0.5,background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>{t.settings}</div>
      </div>

      {/* Single column on mobile, 2-column on desktop */}
      <div style={{ display: isDesktop ? "grid" : "flex", gridTemplateColumns: isDesktop ? "1fr 1fr" : undefined, flexDirection: isDesktop ? undefined : "column", gap:12, alignItems:"stretch", width:"100%" }}>

        {/* Appearance — hide on desktop (toggle is in sidebar) */}
        {!isDesktop && (
          <div style={{background:th.surface,border:`1px solid ${th.border}`,borderRadius:18,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              {dark ? Icons.moon("#ffd60a") : Icons.sun("#8e8e93")}
              <p style={{fontWeight:600,fontSize:15,color:th.text}}>{dark?t.darkMode:t.lightMode}</p>
            </div>
            <Toggle dark={dark} onToggle={toggleDark}/>
          </div>
        )}

        {/* Language */}
        <div style={{background:th.surface,border:`1px solid ${th.border}`,borderRadius:18,overflow:"hidden"}}>
          <div style={{padding:"8px 16px 6px",borderBottom:`1px solid ${th.sep}`}}>
            <p style={{fontSize:11,fontWeight:700,color:th.muted,textTransform:"uppercase",letterSpacing:0.8}}>Language</p>
          </div>
          <div style={{padding:"14px 16px"}}>
            <div style={{display:"flex",gap:8}}>
              {[{code:"en",flag:"🇬🇧",label:"EN"},{code:"fr",flag:"🇫🇷",label:"FR"},{code:"de",flag:"🇩🇪",label:"DE"}].map(l=>(
                <button key={l.code} onClick={()=>setLang(l.code)}
                  style={{ flex:1, padding:"12px 8px", borderRadius:14, border:`1.5px solid ${lang===l.code?"#00e5a0":th.border}`, background: lang===l.code?"rgba(0,229,160,0.12)":th.surface2, color: lang===l.code?"#00e5a0":th.muted, fontSize:13, fontWeight:700, transition:"all 0.2s", display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
                  <span style={{fontSize:22}}>{l.flag}</span>{l.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Vehicle */}
        <div style={{background:th.surface,border:`1px solid ${th.border}`,borderRadius:18,overflow:"hidden"}}>
          <div style={{padding:"8px 16px 6px",borderBottom:`1px solid ${th.sep}`}}>
            <p style={{fontSize:11,fontWeight:700,color:th.muted,textTransform:"uppercase",letterSpacing:0.8}}>{t.vehicle}</p>
          </div>
          <div style={{padding:"14px 16px"}}>
            <p style={{color:th.muted,fontSize:13,marginBottom:14}}>{t.vehicleSubtitle}</p>
            <div style={{display:"flex",gap:8,marginBottom:14}}>
              {[{type:"petrol",icon:Icons.fuel,label:t.petrol},{type:"diesel",icon:Icons.fuel,label:t.diesel},{type:"electric",icon:Icons.zap,label:t.electric}].map(v=>(
                <button key={v.type} onClick={()=>setLv({...lv,type:v.type})}
                  style={{ flex:1, padding:"12px 8px", borderRadius:14, border:`1.5px solid ${lv.type===v.type?"#00e5a0":th.border}`, background: lv.type===v.type?"rgba(0,229,160,0.12)":th.surface2, color: lv.type===v.type?"#00e5a0":th.muted, fontSize:10, fontWeight:700, transition:"all 0.2s", display:"flex", flexDirection:"column", alignItems:"center", gap:4 }}>
                  {v.icon(lv.type===v.type?"#00e5a0":th.muted)}{v.label}
                </button>
              ))}
            </div>
            {lv.type!=="electric" && (
              <div style={{marginBottom:14}}>
                <label style={{fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:0.8,color:th.muted,display:"block",marginBottom:8}}>{t.consumption}</label>
                <input type="number" value={lv.consumption} onChange={e=>setLv({...lv,consumption:parseFloat(e.target.value)||7})}
                  style={{width:"100%",background:th.surface2,border:`1.5px solid ${th.border}`,borderRadius:14,padding:"13px 16px",color:th.text,fontSize:16,fontFamily:"'DM Sans', sans-serif"}}/>
              </div>
            )}
            <button onClick={()=>saveVehicle(lv)}
              style={{width:"100%",background:"linear-gradient(135deg,#3dffa0 0%,#5b8fff 60%,#c47bff 100%)",border:"none",borderRadius:14,padding:"13px",color:"#000",fontSize:15,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              {Icons.check("#000")}{t.saveSettings}
            </button>
          </div>
        </div>

        {/* About */}
        <div style={{background:th.surface,border:`1px solid ${th.border}`,borderRadius:18,padding:"14px 16px"}}>
          <p style={{fontWeight:700,fontSize:15,marginBottom:6}}>About Cheaperside</p>
          <p style={{color:th.muted,fontSize:13,lineHeight:1.7}}>v2.0 · For cross-border shoppers in CH/FR/DE 🇨🇭🇫🇷🇩🇪<br/>Prices from Eufy, Teufel, OnePlus & more retailers joining soon.</p>
          <div style={{marginTop:10, display:"flex", gap:16}}>
            <a href="https://cheaperside.com/privacy.html" target="_blank" rel="noopener noreferrer" style={{color:th.muted, fontSize:12, textDecoration:"none"}}>Privacy Policy</a>
            <a href="https://cheaperside.com" target="_blank" rel="noopener noreferrer" style={{color:th.muted, fontSize:12, textDecoration:"none"}}>cheaperside.com</a>
          </div>
        </div>

        {/* Affiliate Disclosure (legal compliance) */}
        <div style={{background:th.surface,border:`1px solid ${th.border}`,borderRadius:18,padding:"14px 16px"}}>
          <p style={{fontWeight:700,fontSize:14,marginBottom:6,display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:16}}>ℹ️</span>{t.affiliateNotice}
          </p>
          <p style={{color:th.muted,fontSize:12,lineHeight:1.6,marginBottom:8}}>{t.affiliateText}</p>
          <p style={{color:th.muted,fontSize:11,lineHeight:1.5,fontStyle:"italic"}}>{t.priceDisclaimer}</p>
        </div>

      </div>
    </div>
  );
}
// build Thu Apr 16 09:50:37 UTC 2026
